import React from "react";
import Texture from "../../imgs/textured-bg.png";
// import panda from "../../imgs/panda.png";
import panda from "../../imgs/panda-1.png";
import panda2 from "../../imgs/panda-2.png";
// import Footerimg from "../../imgs/footer-img.png";
import Banner from "../../imgs/banner.png";

export default function Roadmap() {
  return (
    <div className="roadmap" style={{ backgroundImage: `url(${Texture})` }}>
      <img className="banner" src={Banner} />
      {/* <img className="footer-img" src={Footerimg} /> */}
      <div className="roadmap-container">
        <h6 className="text-xl text-dark losnello">Updated Roadmap 2.0</h6>
        <p className="text-md text-center text-dark">
          At DG Labs, we like to think in terms of building a brand. The first
          thing you do is lay the blueprint and foundation. As we evolve and
          grow as a community, we'll work towards becoming a leader in the
          phygital space. Speaking of build...
        </p>

        <div className="row">
          <div className="col-md-4 pl-0">
            <img className="panda " src={panda} />
          </div>
          <div className=" col-md-8 d-flex flex-column align-items-start">
            <h6 className="text-lg text-dark  losnello">$Build</h6>
            <div className="line"></div>
            <p className="text-md text-dark text-left mt-3">
              We're proud to be a part of the BUILDsquad, which is a super-DAO
              built by founding members of the Gold Panther DAO. This consists
              of a group of likeminded community members who are holders of a
              number of blue chip and fast rising collections in Solana NFTs.
              The group plans to build a sustainable ecosystem to help onboard
              and foster new projects from ambitious builders. BUILDsqaud has
              pulled together several other projects, including Solluminati,
              Honey Finance, the Fellowship, High Society and others to create a
              “super-stack” of service providers across the NFT space. $build
              will be our token.
            </p>
          </div>
        </div>

        <div className="row reverse-mobile">
          <div className=" col-md-8 d-flex flex-column align-items-start">
            <h6 className="text-lg text-dark  losnello">Free 3D Panda</h6>
            <div className="line"></div>
            <p className="text-md text-dark text-left mt-3">
              Yes, you read that right. We love to reward our community and
              those vibing and enjoying this amazing journey and experience with
              us. For every Dope Panda you own, you get a free 3D Panda. This is
              our way of saying thank you to our holders. And we will continue
              to provide utility for all collections as we grow and scale as a
              NFT art studio.
            </p>
          </div>
          <div className="col-md-4 pl-0">
            <img className="panda" src={panda2} />
          </div>
        </div>

        <div className="row">
          <div className="col-md-4 pl-0">
            <img className="panda " src={panda} />
          </div>
          <div className=" col-md-8 d-flex flex-column align-items-start">
            <h6 className="text-lg text-dark  losnello">Real World utility</h6>
            <div className="line"></div>
            <p className="text-md text-dark text-left mt-3">
              Having a successful painter as one of your founders lets you get
              creative in some of the utility you can offer your community. DG
              Labs awards custom painted AF1’s to the community as their way of
              saying thank you to those making the biggest impact. Merch,
              GSTAKIS' artwork and figurines of the 3D pandas are all in the
              works. The ability to print your specific NFT’s and have them
              delivered world wide via strategic partnerships is also currently
              being fleshed out.
            </p>
            <a
              href="https://drive.google.com/file/d/1rud9IfE-40c3GwmaGK5TBiKMBDmTkQrL/view"
              className="black-btn text-md regular mt-4 mobile-center"
            >
              View
            </a>
          </div>
        </div>

        <div className="row reverse-mobile">
          <div className=" col-md-8 d-flex flex-column align-items-start">
            <h6 className="text-lg text-dark losnello">The Dope Gallery</h6>
            <div className="line"></div>
            <p className="text-md text-dark text-left mt-3">
              The dope gallery will be our massive, custom 1-of-1 3D art gallery
              that will hold exhibitions and auctions of hand-curated art from
              DG Labs artists and external artists. This will be a cross-chain
              spatial gallery, and all of the art will also be purchasable
              inside of the gallery. Access is provided by owning a DG Labs NFT.
              Think of this as our auction house / art exhibition center, and
              it’s going to truly be dope!
            </p>
            <a
              href="https://drive.google.com/file/d/1rud9IfE-40c3GwmaGK5TBiKMBDmTkQrL/view"
              className="black-btn text-md regular mt-4 mobile-center"
            >
              View
            </a>
          </div>
          <div className="col-md-4 pl-0">
            <img className="panda me-3 no-me" src={panda2} />
          </div>
        </div>

        <div className="row">
          <div className="col-md-4 pl-0">
            <img className="panda" src={panda} />
          </div>
          <div className=" col-md-8 d-flex flex-column align-items-start">
            <h6 className="text-lg text-dark  losnello">The Dope Galleries</h6>
            <div className="line"></div>
            <p className="text-md text-dark text-left mt-3">
              After the 3D Intergalactic Pandas, our next major launch will be
              our 3D Dope Galleries. You’ll be able to hang all your NFTs from
              different blockchains inside the gallery. There could even be the
              potential to rent this out so stay tuned for more details and
              timelines as we progress along with this - but the goal is to have
              this ready in Q3/Q4 2022. We won't launch this, until it's ready
              aka when you mint, you'll be able to go straight in to your
              gallery and start vibing.
            </p>
          </div>
        </div>

        <div className="row reverse-mobile">
          <div className=" col-md-8 d-flex flex-column align-items-start">
            <h6 className="text-lg text-dark  losnello">Panda Land</h6>
            <div className="line"></div>
            <p className="text-md text-dark text-left mt-3">
              Over time we'll branch out beyond just the dope galleries and
              create a land where all pandas are welcome to run and play and
              chew on bamboo. This will be broken into several components.
              You'll have the dope galleries, Panda Land city center, the
              stadium where games and events will occur, and panda condos where
              you can go relax and chill.
            </p>
          </div>
          <div className="col-md-4 pl-0">
            <img className="panda" src={panda2} />
          </div>
        </div>

        <div className="row">
          <div className="col-md-4 pl-0">
            <img className="panda no-me" src={panda} />
          </div>
          <div className=" col-md-8 d-flex flex-column align-items-start">
            <h6 className="text-lg text-dark  losnello">
              {" "}
              Scholarship/Incubator Program
            </h6>
            <div className="line"></div>
            <p className="text-md text-dark text-left mt-3">
              Having a heavy focus on art, we are very excited to begin offering
              scholarship programs and incubating artists into the DG Labs
              ecosystem. They will either assist with projects, be hirable by
              other projects or will have their own events and projects. We want
              to make DG Labs a dope space for all artists to feel welcome, no
              matter their background, what language they speak or where in the
              world they come from.
            </p>
          </div>
        </div>

        <div className="row reverse-mobile">
          <div className=" col-md-8 d-flex flex-column align-items-start">
            <h6 className="text-lg text-dark  losnello">3D Panda Benefits</h6>
            <div className="line"></div>
            <p className="text-md text-dark text-left mt-3">
              Come for the art, stay for the utility. People ask what are the
              benefits of owning a 3D Panda in addition to a Dope Panda?
            </p>
          </div>
          <div className="col-md-4 pl-0">
            <img className="panda" src={panda2} />
          </div>
        </div>

        <div className="row">
          <div className="col-md-4 pl-0">
            <img className="panda no-me  no-margin " src={panda} />
          </div>
          <div className=" col-md-8 d-flex flex-column align-items-start">
            <h6 className="text-lg text-dark  losnello"> Coming Soon</h6>
            <div className="line"></div>
            <p className="text-md text-dark mb-2 mt-3">
              * AR & Metaverse compatability on the 3D Pandas post launch
            </p>
            <p className="text-md text-dark mb-2">
              * Discounts on figurines, merch and custom artwork/kicks
            </p>
            <p className="text-md text-dark mb-2 ">
              *Stake and earn $build (once $build is finalized)
            </p>
            <p className="text-md text-dark mb-3 ">
              * Raffle of prizes post mint (both physical and digital)
            </p>
            <p className="text-md text-dark text-left mt-3">
              Our brand is built through community. A map can only take you as
              far as has been explored. We're still so early in terms of what
              NFTs and the metaverse can offer, so let's enjoy this journey
              together.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
